import { render, staticRenderFns } from "./BackofficeCadastroMedicoConviteTable.vue?vue&type=template&id=7faf2ba7&scoped=true"
import script from "./BackofficeCadastroMedicoConviteTable.vue?vue&type=script&lang=ts"
export * from "./BackofficeCadastroMedicoConviteTable.vue?vue&type=script&lang=ts"
import style0 from "./BackofficeCadastroMedicoConviteTable.vue?vue&type=style&index=0&id=7faf2ba7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7faf2ba7",
  null
  
)

export default component.exports